import { createContext } from 'react'

export interface Category {
  id: string
  name: string
}

export type Categories = Category[]

export const EditorPageContext = createContext<{ categories?: Categories }>({})
EditorPageContext.displayName = 'EditorPageContext'

export const EditorPageContextProvider = EditorPageContext.Provider
